export enum CustomRulesSidePanelEvents {
  EDIT = 'edit',
  DELETE = 'delete',
  SCAN = 'scan',
  GET_PREV_RULE = 'getprevrule',
  GET_NEXT_RULE = 'getnextrule',
}
